import {map} from 'lodash-es';
import {MachineTechnicalWeaveSettingsRevision} from './machine-technical-weave-settings-revision';

export class MachineTechnicalWeaveSettings {
  private readonly _type: string;
  private readonly _revisions: MachineTechnicalWeaveSettingsRevision[];

  public constructor(type: string, revisions: MachineTechnicalWeaveSettingsRevision[]) {
    this._type = type;
    this._revisions = revisions;
  }

  public static fromJSON(machineTechnicalWeaveSettings: any): MachineTechnicalWeaveSettings {
    return new MachineTechnicalWeaveSettings(
      machineTechnicalWeaveSettings.type,
      map(machineTechnicalWeaveSettings.revisions, (revision: any) => {
        return MachineTechnicalWeaveSettingsRevision.fromJSON(revision);
      })
    );
  }

  public get type(): string {
    return this._type;
  }

  public get revisions(): MachineTechnicalWeaveSettingsRevision[] {
    return this._revisions;
  }

  public toJSON(): JSON {
    return {
      type: this._type,
      revisions: map(this._revisions, (revision: MachineTechnicalWeaveSettingsRevision) => revision.toJSON())
    } as any as JSON;
  }
}
